import React, { useState } from 'react'
import SubHeader from '../general/SubHeader'
import ResponseMsg from '../general/ResponseMsg';

const Support = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        productName: '',
        description: '',
        files: []
    });

    const handleFileChange = (e) => {
        const files = e.target.files;
        const maxFileSize = 30 * 1024 * 1024;
        let valid = true;
    
        // Loop through the selected files to check the file size
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > maxFileSize) {
                valid = false;
                setErrorMessage('Each video or image file must be under 30MB.');
                break;
            }
        }
    
        if (valid) {
            setErrorMessage('');
            setFormData({
                ...formData,
                files: files
            });
        }
    };
    

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    
    //     // If no files are selected, return early
    //     if (formData.files.length === 0) {
    //         setErrorMessage('Please select at least one file.');
    //         return;
    //     }
    
    //     const message = `*Alert! Customer Support Needed*\n
    //         *Name*: ${formData.name}
    //         *Mobile*: ${formData.mobile}
    //         *Email*: ${formData.email}
    //         *Product Using*: ${formData.productName}
    //         *Issue Description*: ${formData.description}
    //     `;
    
    //     const uploadedFileUrls = await uploadFiles(formData.files);
    
    //     let fileUrlsMessage = '';
    //     if (uploadedFileUrls.length > 0) {
    //         fileUrlsMessage = '\n*Check Files*: ' + uploadedFileUrls.join(', ');
    //     }

    // const footerMessage = `\n\nRegards,
    // *Dectwin Services*`
    //     const completeMessage = encodeURIComponent(message + fileUrlsMessage + footerMessage);
    
    //     const whatsappLink = `https://wa.me/8957857276?text=${completeMessage}`;
    //     window.open(whatsappLink, '_blank');
    //     setFormData({
    //         name: '',
    //         mobile: '',
    //         email: '',
    //         productName: '',
    //         description: '',
    //         files: []
    //     })
    // };
    

    // Function to handle file upload to backend server
    const uploadFiles = async (files) => {
        const formData = new FormData();
        
        // Append each file to formData
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
        }
    
        try {
            const response = await fetch('https://api.dectwincam.com/api/upload-file', {
                method: 'POST',
                body: formData
            });
    
            const data = await response.json();
            console.log(data);
            if (response.ok) {
                return data.fileUrls;
            } else {
                setErrorMessage('Failed to upload files');
                return [];
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Error uploading files');
            return [];
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (formData.files.length === 0) {
            setErrorMessage('Please select at least one file.');
            return;
        }
    
        const uploadedFileUrls = await uploadFiles(formData.files);
    
        // If file upload fails, stop form submission
        if (uploadedFileUrls.length === 0) {
            setErrorMessage('Failed to upload files');
            return;
        }
    
        const message = {
            name: formData.name || 'NA',
            mobile: formData.mobile || 'NA',
            email: formData.email || 'NA',
            productName: formData.productName || 'NA',
            description: formData.description || 'NA',
            files: uploadedFileUrls || 'NA',
        };
    
        try {
            // Send the form data (including file URLs) to the backend
            const response = await fetch('https://api.dectwincam.com/api/send-whatsapp-message', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(message),
            });
    
            const data = await response.json();
            if (response.ok) {
                setResponse('Your support ticket has been submitted successfully!');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
                setFormData({
                    name: '',
                    mobile: '',
                    email: '',
                    productName: '',
                    description: '',
                    files: []
                });
                setErrorMessage('');
            } else {
                setErrorMessage('Failed to send message');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Error sending WhatsApp message');
            setResponse('Error');
        }
    };
    

    return (
        <>
            <SubHeader message='Support' />

            <section className='my-5'>
                <div className='container'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Need Support?</p>
                    <p className='sec-heading my-0'>Reach Out to Us</p>
                    <p className='text-muted fw-semibold'>Reach us for expert assistance! We are here to solve your issues and make our
                        products bring more enhanced experience for you. Our team is ready to provide
                        solutions, answer queries, and ensure to serve you best every step of the way.</p>

                    <div className='form-area mt-5 col-lg-10'>
                        <form class="row g-3" onSubmit={handleSubmit}>
                            <div class="col-12">
                                <input type="text" class="support-input" id="name" value={formData.name}
                                    onChange={handleChange} placeholder='Your Name' required />
                            </div>
                            <div class="col-md-6">
                                <input type="tel" class="support-input" id="mobile" value={formData.mobile} onChange={handleChange}
                                    placeholder='Mobile Number' required />
                            </div>
                            <div class="col-md-6">
                                <input type="email" class="support-input" id="email" value={formData.email} onChange={handleChange}
                                    placeholder='Email Address' />
                            </div>

                            <div class="col-12">
                                <input type="text" class="support-input" id="productName" value={formData.productName} onChange={handleChange}
                                    placeholder='Product Name' required />
                            </div>

                            <div className="col-12">
                            <input type="file" className="support-input" id="inputFiles" multiple accept="image/*, video/*" name='files' onChange={handleFileChange} />
                            <small className="text-muted">*Upload image or video showcasing the issue.</small>
                                {errorMessage && <p className="text-danger mt-2">*{errorMessage}</p>}
                            </div>

                            <div class="col-12">
                                <textarea type="text" class="support-input" id="description" value={formData.description} onChange={handleChange}
                                    style={{ height: '8em' }} placeholder='Describe your issue..'></textarea>
                            </div>
                            <div class="col-12">
                                <button type="submit" class="banner-btn1">Submit</button>
                            </div>
                        </form>
                    </div>
                    {/* form area ends */}

                </div>
            </section>

            {response && <ResponseMsg message={response} />}
        </>
    )
}

export default Support
